import store from "@/state/store";
import GenericErrorPage from '@/views/errors/GenericErrorPage.vue';

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      gtm: "Login",
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Dashboard" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      gtm: "Register",
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      gtm: "Forgot Password",
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "Dashboard" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },  
  {
    path: "/verify-email",
    name: "VerifyEmail",
    component: () => import("../views/account/EmailVerificationAction.vue"),
    meta: {
      gtm: "Email Verification",
      title: "Email Verification",
      authRequired: false,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/account/ResetPasswordAction.vue"),
    meta: {
      gtm: "Reset Password",
      title: "Reset Password",
      authRequired: false,
    },
  },
  {
    path: "/email-actions",
    name: "EmailActions",
    component: () => import("../views/account/EmailActionDispatcher.vue"),
    meta: {
      gtm: "Email Action",
      title: "Email Action",
      authRequired: false,
    },
  },
  // Language-specific landing pages
  {
    path: '/',
    name: 'MysticLog',
    meta: {
      gtm: 'Landing Page',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: '/pt',
    name: 'LandingPT',
    meta: {
      gtm: 'Landing Page PT',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: '/es',
    name: 'LandingES',
    meta: {
      gtm: 'Landing Page ES',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: '/fr',
    name: 'LandingFR',
    meta: {
      gtm: 'Landing Page FR',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: '/it',
    name: 'LandingIT',
    meta: {
      gtm: 'Landing Page IT',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: '/de',
    name: 'LandingDE',
    meta: {
      gtm: 'Landing Page DE',
      authRequired: false,
    },
    component: () => import('../views/landingPage/index.vue'),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      gtm: "Dashboard",
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/home/index.vue"),
  },    
  {
    path: "/readings/add-reading",
    name: "Add new reading",
    meta: { gtm: "Add new reading", title: "Add new reading", authRequired: true },
    component: () => import("../views/readings/add-reading"),
  },
  {
    path: "/readings/",
    name: "Readings History",
    meta: { gtm: "Readings History", title: "Readings History", authRequired: true },
    component: () => import("../views/readings/index"),
  },
  {
    path: "/readings/:readingId",
    name: "Reading Details",
    meta: { gtm: "Reading Details", title: "Reading Details", authRequired: true },
    component: () => import("../views/readings/reading-details"),
  },
  {
    path: "/edit-reading/:readingId",
    name: "Edit Reading",
    meta: { gtm: "Edit Reading", title: "Edit Reading", authRequired: true },
    component: () => import("../views/readings/edit-reading"),
  },
  {
    path: "/profile/",
    name: "Edit Profile",
    meta: { gtm: "Edit Profile", title: "Edit Profile", authRequired: true },
    component: () => import("../views/profile/index"),
  }, 
  {
    path: "/manage-subscription/",
    name: "Manage Subscription",
    meta: { gtm: "Manage Subscription", title: "Manage Subscription", authRequired: true },
    component: () => import("../views/profile/manage-subscription"),
  },   
  {
    path: "/querents/",
    name: "Querents",
    meta: { gtm: "Querents", title: "Your Querents", authRequired: true },
    component: () => import("../views/querents/index"),
  }, 
  {
    path: "/querents/:id",
    name: "QuerentDetails",
    meta: { gtm: "Querent Details", title: "Querent Details", authRequired: true },
    component: () => import("../views/querents/querent-details"),
  },
  {
    path: "/add-querent/",
    name: "Add Querent",
    meta: { gtm: "Add Querent", title: "Add or Edit Querents", authRequired: true },
    component: () => import("../views/querents/add-querent"),
  },  
  {
    path: "/edit-querent/:id",
    name: "Edit Querent",
    meta: { gtm: "Edit Querent", title: "Add or Edit Querents", authRequired: true },
    component: () => import("../views/querents/add-querent"),
  },
  {
    path: "/reading-types/",
    name: "Reading Types",
    meta: { gtm: "Reading Types", title: "Your Reading Types", authRequired: true },
    component: () => import("../views/readingTypes/index"),
  },  
  {
    path: "/add-reading-type/",
    name: "Add Reading Type",
    meta: { gtm: "Add Reading Type", title: "Add Reading Types", authRequired: true },
    component: () => import("../views/readingTypes/add-reading-type"),
  }, 
  {
    path: "/edit-reading-type/:id",
    name: "Edit Reading Type",
    meta: { gtm: "Edit Reading Type", title: "Edit Reading Types", authRequired: true },
    component: () => import("../views/readingTypes/add-reading-type"),
  },      
  {
    path: "/share/:token",
    name: "Shared Reading",
    meta: { gtm: "Shared Reading", title: "View Reading", authRequired: false },
    component: () => import("../views/readings/SharedReadingView.vue"),
  },
  // Support Ticket Routes
  {
    path: "/affiliate",
    name: "Affiliate",
    meta: { gtm: "Affiliate", title: "Affiliate", authRequired: true },
    component: () => import("../views/affiliate/index"),
  },
  {
    path: "/support/contact",
    name: "ContactSupport",
    meta: { gtm: "Contact Support", title: "Contact Support", authRequired: true },
    component: () => import("../views/support/ContactSupportForm.vue"),
  },
  {
    path: "/support/tickets",
    name: "MySupportTickets",
    meta: { gtm: "My Support Tickets", title: "My Support Tickets", authRequired: true },
    component: () => import("../views/support/MySupportTicketsList.vue"),
  },
  {
    path: "/support/tickets/:ticketId",
    name: "TicketConversation",
    meta: { gtm: "Ticket Conversation", title: "Ticket Conversation", authRequired: true },
    component: () => import("../views/support/TicketConversationView.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    meta: { gtm: "Privacy Policy", title: "Privacy Policy", authRequired: false },
    component: () => import("../views/legal/PrivacyPolicy.vue"),
  },  
  {
    path: "/terms",
    name: "Terms of Services",
    meta: { gtm: "Terms of Services", title: "Terms of Services", authRequired: false },
    component: () => import("../views/legal/TermsOfServices.vue"),
  },  
  {
    path: '/:pathMatch(.*)*', // This is a catch-all for 404 Not Found errors
    name: 'NotFound',
    component: GenericErrorPage,
    props: {
      errorCode: '404',
      title: 'Page Lost in the Astral Plane!',
      message: 'The page you seek has wandered off the beaten path. Perhaps it\'s exploring other dimensions? Let\'s return to the sanctuary of our homepage.',
    },
    meta: {
      title: 'Page Not Found',
      public: true, // Or false if you want it behind auth for some reason
    }
  },
  {
    path: '/mysticassistant',
    name: 'MysticAssistant',
    component: () => import('@/views/assistant/MysticAssistant.vue'),
    //meta: { requiresAuth: true }
    meta: { gtm: "Mystic Assistant", title: "Mystic Assistant", authRequired: true },
  }      
];